import { render, staticRenderFns } from "./ActivateCheckpoint.vue?vue&type=template&id=61b75e7f"
import script from "./ActivateCheckpoint.vue?vue&type=script&lang=js"
export * from "./ActivateCheckpoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports